export default class StoreLocator
{
	constructor(node)
	{
		this.node = node;
		this.geocoder = new google.maps.Geocoder();
		this.autocomplete = new google.maps.places.Autocomplete(this.node.querySelector('input.search'), {});
		this.puntiVendita = [];
		this.searchPosition = {};
		this.searchRangeKm = window.storeLocatorSettings.searchRangeKm;

		this.initMap();

		var storeTpl = this.node.querySelector('.blocco-store-tpl');
		storeTpl.classList.remove('blocco-store-tpl');
		storeTpl.removeAttribute('style');
		this.storeTpl = storeTpl.cloneNode(true);
		storeTpl.remove();

		this.addListeners();

		this.searchByUrl();
	}

	static init()
	{
		let storeLocatorNode = document.querySelector("[data-store-locator]");

		if (storeLocatorNode)
		{
			return new StoreLocator(storeLocatorNode);
		}
	}

	searchByUrl()
	{
		location.queryString = {};

		location.search.substr(1).split("&").forEach(function (pair)
		{
			if (pair === "") return;
			let parts = pair.split("=");
			location.queryString[parts[0]] = parts[1] &&
				decodeURIComponent(parts[1].replace(/\+/g, " "));
		});

		if (location.queryString.search !== undefined && location.queryString.searchPosition === undefined)
		{
			// L'utente ha cercato un luogo senza utilizzare l'autocomplete.
			this.node.querySelector('input.search').value = location.queryString.search;
			this.node.querySelector('input[type="button"]').click();
		} else if (location.queryString.searchPosition !== undefined)
		{
			// L'utente ha cercato un luogo utilizzando l'autocomplete, i risultati di ricerca sono nell'url.
			this.node.querySelector('input.search').value = location.queryString.search;

			let latLng = location.queryString.searchPosition.split(",");
			let searchLatLng = new google.maps.LatLng(latLng[0], latLng[1]);
			this.searchPosition = searchLatLng;

			let addressComponents = [];
			addressComponents.push({
				types: ["administrative_area_level_1"],
				short_name: location.queryString.administrativeArea
			});
			addressComponents.push({
				types: ["country"],
				short_name: location.queryString.country
			});

			this.getPuntiVendita(searchLatLng, addressComponents);

			this.scrollWindowToSearch();
		}
	}

	initMap()
	{
		this.mapNode = this.node.querySelector('#map-container');

		this.googleMap = new google.maps.Map(this.mapNode, {
			center: { lat: 52.515897, lng: 13.402780 },
			zoom: 3,
			disableDefaultUI: true,
			zoomControl: true,
			styles: [
				{
					"featureType": "administrative",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9c9c9c"
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "all",
					"stylers": [
						{
							"color": "#f7f7f7"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "labels.text",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "all",
					"stylers": [
						{
							"saturation": -100
						},
						{
							"lightness": 45
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "all",
					"stylers": [
						{
							"color": "#ededed"
						},
						{
							"visibility": "on"
						}
					]
				}
			]
		});
	}

	clearMarkers()
	{
		if (this.searchPosition.marker)
		{
			this.searchPosition.marker.setMap(null);
			this.searchPosition.marker = null;
		}

		this.puntiVendita.forEach((puntoVendita) =>
		{
			if (puntoVendita.marker)
			{
				puntoVendita.marker.setMap(null);
				puntoVendita.marker = null;
			}
		});
	}

	updateViewport()
	{
		let markerBounds = new google.maps.LatLngBounds();

		// La viewport contiene, se possibile, la geometria del luogo cercato (via, città, nazione...)...
		if (this.autocomplete.getPlace() && this.autocomplete.getPlace().geometry)
		{
			markerBounds = this.autocomplete.getPlace().geometry.viewport;
		} else if (location.queryString !== undefined && location.queryString.viewport !== undefined)
		{
			// (la geometria eventualmente può essere passata tramite query-string (ie: l'utente ha cercato la città tramite box nel footer))
			let viewportCoords = location.queryString.viewport.split(",");
			markerBounds = new google.maps.LatLngBounds(new google.maps.LatLng(viewportCoords[0], viewportCoords[1]), new google.maps.LatLng(viewportCoords[2], viewportCoords[3]));
		}

		// ...e include sempre il pin del punto cercato...
		if (this.searchPosition.marker)
		{
			markerBounds.extend(this.searchPosition.marker.getPosition());
		}

		// ...e il marker più vicino.
		if (this.puntiVendita.length && this.puntiVendita[0].marker)
		{
			markerBounds.extend(this.puntiVendita[0].marker.getPosition());
		}

		this.googleMap.setCenter(markerBounds.getCenter());
		this.googleMap.fitBounds(markerBounds, 75);
	}

	updateMarkers()
	{
		let _this = this;

		this.searchPosition.marker = new google.maps.Marker({
			position: { lat: this.searchPosition.lat(), lng: this.searchPosition.lng() },
			map: this.googleMap,
			icon: {
				path: google.maps.SymbolPath.CIRCLE,
				fillColor: 'white',
				fillOpacity: 0.8,
				scale: 5,
				strokeColor: 'black'
			}
		});

		this.puntiVendita.forEach((puntoVendita) =>
		{
			let markerIcon = {
				url: puntoVendita.markerImageUrl,
				scaledSize: new google.maps.Size(50, 50)
			};

			let marker = new google.maps.Marker({
				position: { lat: puntoVendita.lat, lng: puntoVendita.lng },
				map: this.googleMap,
				title: puntoVendita.address.Azienda,
				icon: markerIcon,
				markerIcon: markerIcon
			});

			_this.activeInfoWindow = null;

			marker.addListener('click', () =>
			{
				// Apertura popup.

				//$('.store-mappa #map .cont-tit-map').addClass('disabled'); // disabilito l'input delle ricerca dalla mappa

				if (_this.activeInfoWindow)
				{
					_this.activeInfoWindow.close();
				}

				let infoWindowHtml = '<div class="popup-store" style="padding: 10px; max-width: 250px;">' +
					'<div class="tit extrasmall">' + puntoVendita.address.Azienda + '</div>' +
					'<div class="cta"><a class="link-info" href="#" data-store-id-link="' + puntoVendita.CodiceCalligaris + '">' + window.storeLocatorSettings.labels.dettagliCta + '</a></div>' +
					'</div>';

				_this.activeInfoWindow = new google.maps.InfoWindow({
					content: infoWindowHtml
				});

				_this.activeInfoWindow.open(_this.googleMap, marker);

				// Highlight icona marker.
				_this.highlightMarker(marker);
                
				console.log('ho cliccato sul pin della mappa');

				// riabilito l'input delle ricerca dalla mappa
				google.maps.event.addListener(_this.activeInfoWindow, 'closeclick', function ()
				{
					$('.store-mappa #map .cont-tit-map').removeClass('disabled');
				});

			});

			puntoVendita.marker = marker;
		});
	}

	updateListingPuntiVendita()
	{
		var _this = this;
		let listingNode = this.node.querySelector('.store-stores .flex');

		listingNode.innerHTML = '';

        this.node.querySelector('.no-results-found').style.display = this.puntiVendita.length ? 'none' : 'block';

		this.puntiVendita.forEach((puntoVendita) =>
		{
			let storeNode = _this.storeTpl.cloneNode(true);

			storeNode.setAttribute('data-store', puntoVendita.tipologia.ID);
			storeNode.setAttribute('data-store-id', puntoVendita.CodiceCalligaris);
			storeNode.querySelector('.store-type-icon').style.backgroundImage = "url(" + puntoVendita.markerImageUrl + ")";
			storeNode.querySelector('.tit-type').innerHTML = puntoVendita.tipologia.Nome;
			storeNode.querySelector('.tit').innerHTML = puntoVendita.address.Azienda;
			storeNode.querySelector('.tel').innerHTML = 'Tel. <a href="tel:' + puntoVendita.address.Telefono + '">' + puntoVendita.address.Telefono + '</a>';

			var indirizzo = puntoVendita.address.Indirizzo + '<br/>' +
				puntoVendita.address.CAP + ' ' + puntoVendita.address.Citta +
				' (' + puntoVendita.address.Indirizzo2 + ') ' + puntoVendita.address.NazioneTxt;

			storeNode.querySelector('.indirizzo').innerHTML = indirizzo;
			storeNode.querySelector('.link-store-page').href = puntoVendita.url;
			storeNode.querySelector('.link-directions').href = puntoVendita.gmapDirectionsUrl;

			listingNode.appendChild(storeNode);
		});

	}

	addListeners()
	{
		let _this = this;

		this.autocomplete.addListener('place_changed', function ()
		{
			let autocompletePlace = _this.autocomplete.getPlace();

			if (autocompletePlace && autocompletePlace.geometry)
			{
				// Ho selezionato un opzione autcomplete.
				_this.getPuntiVendita(autocompletePlace.geometry.location, autocompletePlace.address_components);
			} else
			{
				// Ho premuto invio ma non ho selezionato alcuna opzione autocomplete.
				_this.geocoder.geocode({ address: _this.node.querySelector('.search-form input[type="text"]').value }, (results, status) =>
				{
					_this.getPuntiVendita(results[0].geometry.location, results[0].address_components);
				});
			}

			//_this.scrollWindowToSearch();
		});

		this.node.querySelector('#btnFindAddress').addEventListener('click', (event) =>
		{
			event.preventDefault();

			// Ho premuto il tasto "trova posizione", non ho selezionato alcuna opzione autocomplete.
			_this.geocoder.geocode({ address: _this.node.querySelector('.search-form input[type="text"]').value }, (results, status) =>
			{
				_this.getPuntiVendita(results[0].geometry.location, results[0].address_components);
			});

			//_this.scrollWindowToSearch();

			return false;
		});

		this.node.querySelector('#btnLocalizeMe').addEventListener('click', (event) =>
		{
			event.preventDefault();

			// Ho premuto il tasto "localizzami"
			if (navigator.geolocation)
			{
				navigator.geolocation.getCurrentPosition(function (position)
				{
					var pos = { lat: position.coords.latitude, lng: position.coords.longitude };
					var geocoder = new google.maps.Geocoder;

					geocoder.geocode({ 'location': pos }, function (results, status)
					{
						if (status === 'OK')
						{
							if (results[0])
							{
								Log("Store Locator > '" + results[0].formatted_address + "'");
								_this.node.querySelector('.search-form input[type="text"]').value = results[0].formatted_address;
								_this.getPuntiVendita(results[0].geometry.location, results[0].address_components);
							} else
							{
								window.alert('No results found');
							}
						} else
						{
							window.alert('Geocoder failed due to: ' + status);
						}
					});

				}, function ()
				{
					// Geolocation service failed
					window.alert('Error: The Geolocation service failed.');
				});
			} else
			{
				// Browser doesn't support Geolocation
				window.alert('Error: Your browser doesn\'t support geolocation.');
				_this.node.querySelector('#btnLocalizeMe').style.display = 'none';
			}

			//_this.scrollWindowToSearch();

			return false;
		});

		this.node.querySelector('.search-form').addEventListener('submit', (event) =>
		{
			event.preventDefault();
			return false;
		});

		this.node.querySelector('.store-stores .flex').addEventListener('click', (event) =>
		{
			let selectedNode = event.target.closest('[data-store-id]');
			let storeId = selectedNode.getAttribute('data-store-id');

			// Highlight dello store box cliccato.
			_this.node.querySelectorAll('.store-stores [data-store-id]').forEach(function (el) { el.classList.remove('highlight'); });
			selectedNode.classList.add('highlight');
			console.log("ho cliccato sulla lista di sinistra");
			//console.log($('.store-stores .highlight').offset().top);

			_this.puntiVendita.forEach(function (puntoVendita)
			{
				if (puntoVendita.CodiceCalligaris === storeId)
				{
					// Highlight del marker corrispondente.
					_this.highlightMarker(puntoVendita.marker);

					// Centro mappa su marker appena evidenziato.
					_this.googleMap.panTo(puntoVendita.marker.getPosition());
				}
			});
		});

		this.node.querySelector('.store-mappa').addEventListener('click', (event) =>
		{
			if (!event.target.classList.contains('link-info'))
			{
				return;
			}

			event.preventDefault();
            
            // rimozione eventuale filtro attivo
            let filtroAttivo = _this.node.querySelector('.filtri-store .my-filtro.active a');
            if (filtroAttivo != null) {
                filtroAttivo.click();
            }

            _this.node.querySelectorAll('.store-stores [data-store-id]').forEach(function (el) {
                el.classList.remove('highlight');
            });

            // highlight + scroll listing items
            let storeId = event.target.getAttribute('data-store-id-link');
            let puntoVenditaListingItem = _this.node.querySelector('.store-stores [data-store-id="' + storeId + '"]');
            puntoVenditaListingItem.classList.add('highlight');
            if (window.innerWidth > 991) {
                _this.node.querySelector('.overflow-filter').scrollTop = puntoVenditaListingItem.offsetTop - 100;
            }
            else {
                _this.scrollWindowToStore(storeId);
            }
            
			return false;
		});
	}

	scrollWindowToSearch()
	{
		$('html, body').animate({
			scrollTop: $(".search-form").offset().top - 75
		}, 500);
		// console.log('hai cercato la mappa');
	}

	scrollWindowToStore(storeId)
	{
		$('html, body').animate({
			scrollTop: $('[data-store-id="' + storeId + '"]').offset().top - 100
		}, 500);
		// console.log('cosa hai fatto?');
	}

	highlightMarker(marker)
	{
		if (this.selectedMarker)
		{
			this.selectedMarker.setIcon(this.selectedMarker.markerIcon);
		}

		let highlightIcon = {
			url: '/docs/assets/img/store/pin_over.svg',
			scaledSize: new google.maps.Size(50, 50)
		};

		marker.setIcon(highlightIcon);

		this.selectedMarker = marker;
	}

	getPuntiVendita(location, addressComponents)
	{
		let _this = this;
        
        let startSearchText = this.node.querySelectorAll('.start-search-text');
        if (startSearchText != null) {
            startSearchText.forEach(_ => _.remove());    
        }

		if (typeof (dataLayer) !== "undefined")
			try
			{
				var txt = this.node.querySelector('input.search').value;
				dataLayer.push({ 'event': 'cerca negozio', 'label': txt });
				Log("DataLayer > cerca negozio");
			}
			catch (e)
			{
				Log("DataLayer > " + e);
			}

		let xhrData = {
			lat: location.lat(),
			lng: location.lng(),
			administrativeArea: "",
			country: ""
		};

		for (let i in addressComponents)
		{
			let addressComponent = addressComponents[i];

			for (let t in addressComponent.types)
			{
				let addressComponentType = addressComponent.types[t];

				if (addressComponentType === "administrative_area_level_1")
				{
					xhrData.administrativeArea = addressComponent.short_name;
				} else if (addressComponentType === "country")
				{
					xhrData.country = addressComponent.short_name;
				}
			}
		}

		let xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function ()
		{
			if (this.readyState !== 4)
			{
				return;
			}

			var response = JSON.parse(this.response);
			// console.log(response);

			_this.clearMarkers();

			_this.searchPosition = location;
			_this.puntiVendita = response.d.puntiVendita;

			_this.updateListingPuntiVendita();
			_this.updateMarkers();
			_this.updateViewport();
		};
		xhr.open('POST', '/ws/wsStoreSearch.asmx/SearchPuntiVendita');
		xhr.setRequestHeader("Content-Type", "application/json");
		xhr.send(JSON.stringify(xhrData));

		if (!this.node.querySelector('#map').classList.contains('active'))
		{
			this.node.querySelector('#map').classList.toggle('active');
			this.node.querySelector('.store-filtri').classList.toggle('active');
			this.node.querySelector('.store-stores').classList.toggle('active');
			this.node.querySelector('.store-list').classList.toggle('disactive');
		}
	}

	submitSearch()
	{
		let _this = this;
		let searchAddress = this.node.querySelector('form input[type="text"]').value;

		this.geocoder.geocode({ address: searchAddress }, (results, status) =>
		{
			_this.getPuntiVendita(results[0].geometry.location, results[0].address_components);
		});
	}
}
